import pathOr from 'ramda/src/pathOr';

import ConsumerErrorPayload from './ConsumerErrorPayload';
import ErrorType from '../../Constants/Error.type';
import HttpType from '../../Constants/Http.type';
import ConsumerErrorId from '../../Constants/ConsumerErrorId';
import ConsumerErrorCategory from '../../Constants/ConsumerErrorCategory';
import ConsumerErrorStatus from '../../Constants/ConsumerErrorStatus';

const API_ERROR_CODE_GENERIC = '10000';
const extractHttpStatus = error => pathOr(ConsumerErrorStatus.GENERIC, ['response', 'status'], error).toString();
const extractApiErrorCode = error => pathOr(API_ERROR_CODE_GENERIC, ['response', 'data', 'odata.error', 'code'], error);
const mapApiErrorCodeToConsumerErrorId = apiErrorCode => apiErrorCode.toString().substring(2);

const mapToApiServicePlayback = error => {
    const httpStatus = extractHttpStatus(error.source);
    const httpErrorCode = () => pathOr(null, [HttpType[httpStatus]], ConsumerErrorId);
    const serviceErrorCode = () => mapApiErrorCodeToConsumerErrorId(extractApiErrorCode(error.source));

    const errorCode = {
        category: ConsumerErrorCategory.API_SERVICE_PLAYBACK,
        id: httpErrorCode() || serviceErrorCode(),
        status: httpStatus,
    };
    return new ConsumerErrorPayload(errorCode, error);
};

const mapToApiServicePlaybackMissingData = error => {
    const errorCode = {
        category: ConsumerErrorCategory.API_SERVICE_PLAYBACK,
        id: ConsumerErrorId.API_SERVICE_PLAYBACK_MISSING_PLAYBACK_DETAILS,
        status: ConsumerErrorStatus.GENERIC,
    };
    return new ConsumerErrorPayload(errorCode, error);
};

const mapToApiServiceConcurrentUserLimit = error => {
    const errorCode = {
        category: ConsumerErrorCategory.API_SERVICE_PLAYBACK,
        id: ConsumerErrorId.API_SERVICE_PLAYBACK_CONCURRENT_USER_LIMIT,
        status: extractHttpStatus(error.source),
    };
    return new ConsumerErrorPayload(errorCode, error);
};

const mapToApiServiceRestrictedLocation = error => {
    const errorCode = {
        category: ConsumerErrorCategory.API_SERVICE_PLAYBACK,
        id: mapApiErrorCodeToConsumerErrorId(extractApiErrorCode(error.source)),
        status: extractHttpStatus(error.source),
    };
    return new ConsumerErrorPayload(errorCode, error);
};

const mapToPlaybackSourceStartup = error => {
    const errorCode = {
        category: ConsumerErrorCategory.PLAYBACK_SOURCE,
        id: ConsumerErrorId.PLAYBACK_SOURCE_STARTUP,
        status: ConsumerErrorStatus.PLAYBACK_SOURCE_STARTUP,
    };
    return new ConsumerErrorPayload(errorCode, error);
};

const mapToPlaybackSourceMidStream = error => {
    const errorCode = {
        category: ConsumerErrorCategory.PLAYBACK_SOURCE,
        id: ConsumerErrorId.PLAYBACK_SOURCE_MIDSTREAM,
        status: ConsumerErrorStatus.PLAYBACK_SOURCE_MIDSTREAM,
    };
    return new ConsumerErrorPayload(errorCode, error);
};

const mapToPlaybackSourceDrm = error => {
    const errorCode = {
        category: ConsumerErrorCategory.PLAYBACK_SOURCE,
        id: ConsumerErrorId.DRM,
        status: ConsumerErrorStatus.DRM,
    };
    return new ConsumerErrorPayload(errorCode, error);
};

const mapToPlaybackConnectionLost = error => {
    const errorCode = {
        category: ConsumerErrorCategory.PLAYBACK_INTERRUPTED_CONNECTION_LOST,
        id: ConsumerErrorId.PLAYBACK_INTERRUPTED_CONNECTION_LOST,
        status: ConsumerErrorStatus.PLAYBACK_INTERRUPTED_CONNECTION_LOST,
    };
    return new ConsumerErrorPayload(errorCode, error);
};

const mapToUnkownError  = error => {
    const httpStatus = extractHttpStatus(error.source);
    const errorCode = {
        category: ConsumerErrorCategory.UNKNOWN,
        id: pathOr(ConsumerErrorStatus.GENERIC, [HttpType[httpStatus]], ConsumerErrorId),
        status: httpStatus,
    };
    return new ConsumerErrorPayload(errorCode, error);
};

const mapToConsumerError = error => {
    switch (error.type) {
        case ErrorType.API_SERVICE_PLAYBACK:
            return mapToApiServicePlayback(error);
        case ErrorType.API_SERVICE_PLAYBACK_MISSING_DATA:
        case ErrorType.API_SERVICE_PLAYBACK_MEDIA_UNAVAILABLE:
        case ErrorType.API_SERVICE_PLAYBACK_ASSET_UNAVAILABLE:
        case ErrorType.API_SERVICE_PLAYBACK_PLAYBACKDETAILS_UNAVAILABLE:
            return mapToApiServicePlaybackMissingData(error);
        case ErrorType.API_SERVICE_PLAYBACK_CONCURRENT_USER_LIMIT:
            return mapToApiServiceConcurrentUserLimit(error);
        case ErrorType.API_SERVICE_PLAYBACK_RESTRICTED_LOCATION:
            return mapToApiServiceRestrictedLocation(error);
        case ErrorType.PLAYBACK_SOURCE_STARTUP:
            return mapToPlaybackSourceStartup(error);
        case ErrorType.PLAYBACK_SOURCE_MIDSTREAM:
            return mapToPlaybackSourceMidStream(error);
        case ErrorType.LICENSE_REQUEST_FAILED:
        case ErrorType.CERTIFICATE_REQUEST_FAILED:
            return mapToPlaybackSourceDrm(error);
        case ErrorType.PLAYBACK_INTERRUPTED_CONNECTION_LOST:
            return mapToPlaybackConnectionLost(error);
        default:
            return mapToUnkownError(error);
    }
};

export default mapToConsumerError;
